import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';

import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { SaveState } from '../../models/commonModels';

import * as SaleArticleActions from './sale-article.action';
import * as SaleArticleModels from '../../models/sale-article/sale-article';
import { SaleArticleSearchModel } from '../../models/sale-article/sale-articleSearch';
import { SaleArticleService } from './sale-article.service';
import { SpecificationListSummaryModel } from '../../models/specification/specification';

import { saveAs } from 'file-saver';

export interface SaleArticleStateModel {
    List: SaleArticleModels.SaleArticleListModel;
    Search: SaleArticleSearchModel;
    Save: SaveState;
    SaleArticle: SaleArticleModels.SaleArticleModel;
    SaleArticleListSummary: SpecificationListSummaryModel;
    FilteredReportLoading: boolean;
  }

@State<SaleArticleStateModel>({
    name: 'saleArticleState',
    defaults: {
      List: null,
      Search: new SaleArticleSearchModel(),
      Save: null,
      SaleArticle: null,
      SaleArticleListSummary: null,
      FilteredReportLoading: null
    }
  })

  @Injectable()

  export class SaleArticleState {

    constructor(
      private helperService: HelperService,
      private saleArticleService: SaleArticleService,
      private bannerService: BannerService
  ) { }

  @Selector()
  static SaleArticleListSummary(state: SaleArticleStateModel) {
    return state.SaleArticleListSummary;
  }

  @Selector()
  static FilteredReportLoading(state: SaleArticleStateModel) {
    return state.FilteredReportLoading;
  }

  @Selector()
  static SaleArticle(state: SaleArticleStateModel) {
    return state.SaleArticle;
  }

  @Selector()
  static List(state: SaleArticleStateModel) {
    return state.List;
  }


  @Selector()
  static Save(state: SaleArticleStateModel) {
    return state.Save;
  }

  @Selector()
  static SaleArticleSearch(state: SaleArticleStateModel) {
    return state.Search;
  }




  @Action(SaleArticleActions.GetList)
  getList(
    context: StateContext<SaleArticleStateModel>,
    action: SaleArticleActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy sprzedanych towarów.';

    context.setState(
      patch({
        List: null
      })
    );

    this.saleArticleService.get(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            List: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('SaleArticleActions.GetList', error);

        this.bannerService.error(errorMessage);
      });

  }


  @Action(SaleArticleActions.SetSearch)
  setSearch(
    context: StateContext<SaleArticleStateModel>,
    action: SaleArticleActions .SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new SaleArticleActions.GetList(action.Search));
  }

  @Action(SaleArticleActions.SetListPage)
  setListPage(
    context: StateContext<SaleArticleStateModel>,
    action: SaleArticleActions .SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new SaleArticleActions.GetList(action.Search));
  }

  @Action(SaleArticleActions.ResetSearch)
  resetSearch(
    context: StateContext<SaleArticleStateModel>
  ) {

    const state = context.getState();

    const search = new SaleArticleSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new SaleArticleActions.GetList(search));
  }

  @Action(SaleArticleActions.GetListSummary)
  getListSummary(
    context: StateContext<SaleArticleStateModel>,
    action: SaleArticleActions.GetListSummary
 ) {

    function patchContext(summary: SpecificationListSummaryModel) {
      context.setState(
        patch({
          SaleArticleListSummary: summary,
        })
      );
    }

    const emptyResponse = new SpecificationListSummaryModel();

    patchContext(null);
    this.saleArticleService.getSummary(action.Search).subscribe ( (summary) => {
      if (summary.Success) {
          patchContext(summary); } else {
              patchContext(emptyResponse);
          }
        },
        (error) => {
            patchContext(emptyResponse);
            this.bannerService.error('Błąd pobierania podsumowania listy towarów.');
            this.helperService.SaveException('SaleArticleActions.GetListSummary', error);
    });
  }

  @Action(SaleArticleActions.GetFilteredReport)
  getFilteredReport(
      context: StateContext<SaleArticleStateModel>,
      action: SaleArticleActions.GetFilteredReport
   ) {
        function patchContext( loading: boolean) {
          context.setState(
            patch ({
              FilteredReportLoading: loading
            })
          );
        }

        patchContext(true);
        const fileName = 'Raport-sprzedane-towary';
        this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

        this.saleArticleService.getFilteredReport(action.Search).subscribe (
              res => {
                const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(file);
                patchContext(false);
              },
              res => {
                patchContext(false);
                this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
              },
              () => {
                patchContext(false);
                this.helperService.consoleLog(' @Action(SaleArticleActions.GetFilteredReport)');
              }
          );
  }

  @Action(SaleArticleActions.DisposeSearch)
  disposeSearch(
      context: StateContext<SaleArticleStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }
}
